import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconSimcardFilledWhite({
	size = "100",
	...props
}: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#CD0400"
					d="M16.699 22.788H9.942c-.345 0-.677-.125-.933-.352l-2.786-2.467a1.37 1.37 0 0 1-.463-1.023V3.003c0-.759.625-1.375 1.396-1.375H16.7c.77 0 1.396.616 1.396 1.375v18.41c0 .76-.625 1.375-1.396 1.375"
				/>
				<path
					fill="#FFF"
					d="M15.938 22.16H9.182c-.345 0-.677-.125-.934-.352L5.463 19.34A1.37 1.37 0 0 1 5 18.318V2.375C5 1.615 5.625 1 6.396 1h9.542c.772 0 1.397.616 1.397 1.375v18.41c0 .76-.625 1.375-1.397 1.375"
				/>
				<path
					fill="#CD0400"
					d="M8.389 11.437h5.9c.668 0 1.21-.533 1.21-1.192v-5.81c0-.658-.542-1.192-1.21-1.192h-5.9c-.669 0-1.21.534-1.21 1.192v5.81c0 .659.541 1.192 1.21 1.192"
				/>
				<path
					fill="#FFF"
					d="M10.293 6.882h5.362c.463 0 .84-.37.84-.826V3.053a.833.833 0 0 0-.84-.826h-5.362c-.463 0-.839.37-.839.826v3.003c0 .456.376.826.84.826"
				/>
				<path
					fill="#FFF"
					fillRule="nonzero"
					d="M16.242 8.812v.703H6.615v-.703z"
				/>
			</g>
		</svg>
	);
}
